import { ClaimItemsGetAdapter } from '../../../adapter';

export default async function ClaimItemsGetUseCase(event) {
    const { id } = event;

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/get-item'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/get-item'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/get-item`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/get-item`;
    
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/get-item';

    const payload = {
        claimId: id
    };

    // handle request
    const result = await ClaimItemsGetAdapter(endpoint, JSON.stringify(payload));

    return result;
}
